import { formatNumber } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '../../core/services/language.service';

@Pipe({
  name: 'operatingHoursPipe',
  standalone: true
})
export class OperatingHoursPipe implements PipeTransform {

  constructor(
    private languageService: LanguageService,
    @Inject(LOCALE_ID) private browserLocale: string
  ) { }

  public transform(value: number | string): string {
    return formatNumber(parseFloat(<string>value), this.getLocale(), '1.0-0');
  }

  private getLocale(): string {
    return this.languageService.getCurrentLocale() ?? this.browserLocale;
  }
}
